if (!customElements.get('soera-size-guide')) {
  customElements.define('soera-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const buttons = this.querySelectorAll('[data-unit]');
      const cells = this.querySelectorAll('[data-cm]');
      const heading = this.querySelector('[data-unit-heading]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const inches = button.dataset.unit === 'in';
        cells.forEach(cell => {
          const cm = Number(cell.dataset.cm);
          cell.textContent = inches && Number.isFinite(cm) ? (cm / 2.54).toFixed(2) : cell.dataset.cm;
        });
        heading.textContent = inches ? heading.dataset.inLabel : heading.dataset.cmLabel;
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }));
      this.classList.add('is-ready');
    }
  });
}
